import { render, staticRenderFns } from "./BottomAlarm.vue?vue&type=template&id=5009caa8&scoped=true"
import script from "./BottomAlarm.vue?vue&type=script&lang=js"
export * from "./BottomAlarm.vue?vue&type=script&lang=js"
import style0 from "./BottomAlarm.vue?vue&type=style&index=0&id=5009caa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5009caa8",
  null
  
)

export default component.exports